import React, { useCallback, useEffect } from 'react';
import { Grid } from '@mui/material';

import OrganizationInfoCard from '../../../common/organization-info-card/OrganizationInfoCard';
import ContactCard from '../../../common/contact-card/ContactCard';
import { useAppDispatch } from '../../../common/hooks/useAppDispatch';
import { useAppSelector } from '../../../common/hooks/useAppSelector';
import {
  fetchBusinessProfileContactById,
  selectBusinessProfileContacts,
} from '../../../slices/business-profile/businessProfileSlice';

interface ContactsTabsProps {
  companyId: number;
  key: string;
}

const ContactsTabs: React.FC<ContactsTabsProps> = ({ companyId }) => {
  const dispatch = useAppDispatch();
  const businessProfileContacts = useAppSelector(selectBusinessProfileContacts);

  const getContacts = useCallback(() => {
    if (!businessProfileContacts) {
      dispatch(fetchBusinessProfileContactById({ id: companyId }));
    }
  }, [businessProfileContacts, dispatch, companyId]);

  useEffect(() => {
    getContacts();
  }, [getContacts]);

  return (
    <>
      <Grid component='div' container wrap='wrap' style={{ rowGap: '16px', paddingBottom: '16px' }}>
        <Grid component='div' size={{ xs: 12 }}>
          <OrganizationInfoCard />
        </Grid>

        <Grid
          component='div'
          size={{ xs: 12 }}
          container
          spacing={2}
          sx={{ flexDirection: 'column' }}
        >
          {(businessProfileContacts?.length ?? 0) > 0 &&
            businessProfileContacts?.map((contact) => (
              <Grid component='div' key={contact.id}>
                <ContactCard contact={contact} companyId={companyId} />
              </Grid>
            ))}
        </Grid>
      </Grid>
    </>
  );
};

export default ContactsTabs;
